import * as React from 'react'
import { TeamDropdownConnected } from './TeamDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TEAM_A_ID } from 'mockState'

export const TeamDropdownExamples = () => {
  return (
    <div className="TeamDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamDropdownConnected teamId={MOCK_TEAM_A_ID} />
      </Provider>
    </div>
  )
}
